import { captureSessionData } from '../../utils/segmentAnalytics'
import Collection from '../collection'

enum Actions {
  Add = 'add',
  Select = 'select',
}

export default class AddFavoritesSportPicker extends Collection {
  private _action: string

  async _onUrlParams({ action, url }: { action: string; url: string }) {
    super._onUrlParams({ url })
    this._action = action
  }

  _init() {
    this._isSportPicker = true
  }

  async $onApiCall(success: boolean) {
    if (this._action === Actions.Add && success) {
      void captureSessionData()
      await super.getCollectionData({ storeLastFocus: true })

      this.currentRow = this._lastFocusedRow
      this.currentTile = this._lastFocusedTile
      this._refocus()
    }
  }
}
